<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Olimpiadas</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="row">
          <div class="col-md-6">
            <div class="col-3">
              <b-form-group
                id="input-group-3"
                label="Estado:  "
                label-for="input-3"
              >
                <b-form-select
                  id="input-3"
                  v-model="selectedStatus"
                  :options="[
                    { text: 'Activas', value: 'list' },
                    { text: 'Inactivas', value: 'listInactive' },
                  ]"
                  required
                  @change="this.loadCourses"
                  class="ml-2 mt-2"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>

          <div class="col-md-6">

            <div class="text-right" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
              <router-link to="/admin-panel/olimpiada/create">
                <b-button variant="primary">
                  <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Crear Olimpiada
                </b-button>
              </router-link>
            </div>

          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <b-table striped hover :items="modulesItems" :fields="fields">

              <!-- A virtual column -->
              <template #cell(actions)="data" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                <b-dropdown id="dropdown-1" text="Acciones" class="m-md-1">
                  <b-dropdown-item>
                    <router-link :to="{ name: 'OlympicsEdit', params: { id: data.item.id}}" >
                      <font-awesome-icon icon="fas fa-edit" />&nbsp;Editar
                    </router-link>
                  </b-dropdown-item>

                  <div v-if="userPermission !== 'ROLE_TEACHER'">
                    <b-dropdown-item v-if="data.item.active == false" @click="enableModule(data.item.id)">
                    <a href="#">
                      <font-awesome-icon icon="fas fa-check-to-slot" />&nbsp;Activar</a>
                  </b-dropdown-item>
                  </div>

                  <div v-if="userPermission !== 'ROLE_TEACHER'">
                    <b-dropdown-item v-if="data.item.active == true" @click="disableModule(data.item.id)">
                      <a href="#">
                      <font-awesome-icon icon="fas fa-ban"/>&nbsp;Desactivar</a>
                    </b-dropdown-item>
                  </div>

                </b-dropdown>
              </template>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"

            ></b-pagination>
          </div>
        </div>
      </div>
      <div v-if="userPermission === 'ROLE_ADMIN' || userPermission === 'ROLE_ENABLING_TEACHER'">

      <!-- DataTales Example -->




    </div>
  </div>
    <!-- /.container-fluid -->

  </div>
  <!-- End of Main Content -->
</template>

<script>
import axios from "axios";

export default {
  name: "CoursesAdmin",
  data: () => {
    return {
      fields: [
        {
          key: 'description',
          sortable: true,
          label: "Olimpiada",
          class: 'w-50'
        },
        {
          key: 'moduleId',
          sortable: true,
          label: "Módulo",
          class: 'w-15'
        },
        {
          key: 'slug',
          sortable: true,
          label: "Slug",
          class: 'w-15'
        },
        {
          key: 'actions',
          label: '',
          sortable: true,
          class: 'w-20'
        }
      ],
      modulesItems: [],
      modulesInactiveItems: [],
      currentPage: 1,
      rows: 10000,
      perPage: 10,
      selectedStatus: "list",
      userPermission: ''
    }
  },
  methods: {
    enableModule(id) {
      let loader = this.$loading.show({});
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/olympic/enable/" + id , {moduleId: id},{
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$router.go();
        console.log(result);
        loader.hide();
      });
    },
    disableModule(id) {
      let loader = this.$loading.show({});
      axios
        .post(
          import.meta.env.VITE_API_BASE_URL + "/api/olympic/disable/" + id,{moduleId: id},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          this.$router.go();
          console.log(result);
          loader.hide();
        });
    },
    loadCourses() {
      let tmpCurrentpage = this.$route.query.currentPage;
      let loader = this.$loading.show({});
      let simulacrumStatus = this.selectedStatus;

      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/olympic/" + simulacrumStatus, {
          params: {
            page: this.currentPage,
            size: this.perPage,
            sort: "DESC",
            search: this.search,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loader.hide();
          this.modulesItems = response.data;
          this.rows = response.data.totalElements;
          if (this.$route.query.currentPage) {
            this.$nextTick(function () {
              this.currentPage = tmpCurrentpage;
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
  },
  beforeMount() {

  },
  watch: {
    currentPage: function () {
      this.loadCourses()
    }
  },
  mounted() {
    this.userPermission =  localStorage.getItem("role")
    this.loadCourses();
  }
};
</script>

<style scoped>

</style>
